'use strict';

import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { ServicesList } from '@src/components/common/services-list/services-list';
import { ServicePropType } from '@src/components/common/service-card/prop-types/service';
import Pagination from '../common/pagination';
import { TextInputField } from '@src/components/ui/react-hook-form/text-Input/text-input';
import { debounce } from 'lodash';

export const StoreFrontItems = ({ goToPage, filters, merchantUser, user, items, searchStoreFront }) => {
    const [keyword, setKeyword] = useState('');

    const handleSearch = useCallback(
        debounce((value, merchantId, pageNumber) => {
            searchStoreFront(value, merchantId, pageNumber);
        }, 600),
        []
    );

    const searchOrUpdateKeyword = e => {
        setKeyword(e.target.value);
        handleSearch(e.target.value, merchantUser.ID, items.PageNumber);
    };

    return (
        <div className='tw-pt-[24px] tw-space-y-[16px]'>
            <div className='tw-flex tw-gap-[8px] tw-items-center'>
                Filter:
                <TextInputField className='tw-grow' size='small' value={keyword} onChange={searchOrUpdateKeyword} />
            </div>
            <ServicesList
                services={items.Records}
                userID={user?.ID}
                className='tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4'
            />
            <Pagination
                totalRecords={items.TotalRecords}
                pageNumber={items.PageNumber}
                pageSize={items.PageSize}
                goToPage={goToPage}
                filters={filters}
            />
        </div>
    );
};

StoreFrontItems.propTypes = {
    goToPage: PropTypes.func.isRequired,
    filters: PropTypes.object,
    merchantUser: PropTypes.shape({
        ID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    }).isRequired,
    user: PropTypes.shape({
        ID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    }),
    items: PropTypes.shape({
        Records: PropTypes.arrayOf(ServicePropType).isRequired,
        TotalRecords: PropTypes.number.isRequired,
        PageNumber: PropTypes.number.isRequired,
        PageSize: PropTypes.number
    }).isRequired,
    searchStoreFront: PropTypes.func.isRequired
};
